module.exports = {
    "development": {
        // "localhost:8080": {
        //     url: "http://dev.api.qarts.partheas.net"
        "dev.kiosk.partheas.dev.qarts.eu": {
            url: "https://api.partheas.dev.qarts.eu"
        }
    },
    "production": {
        "kiosk.mediport.partheas.net": {
            url: "https://api.mediport.partheas.net"
        },
        "kiosk.cdg.partheas.net": {
            url: "https://api.cdg.partheas.net"
        },
        "kiosk.medicis.partheas.net": {
            url: "https://api.medicis.partheas.net"
        },
        "kiosk.ocs.partheas.net": {
            url: "https://api.ocs.partheas.net"
        },
        "kiosk.partheas.partheas.net": {
            url: "https://api.partheas.partheas.net"
        },
        "kiosk.beukenlaan.partheas.net": {
            url: "https://api.beukenlaan.partheas.net"
        },
        "kiosk.devaart.partheas.net": {
            url: "https://api.devaart.partheas.net"
        },
        "kiosk.dhaacht.partheas.net": {
            url: "https://api.dhaacht.partheas.net"
        },
        "kiosk.dkl.partheas.net": {
            url: "https://api.dkl.partheas.net"
        },
        "kiosk.dleie.partheas.net": {
            url: "https://api.dleie.partheas.net"
        },
        "kiosk.cpdiest.partheas.net": {
            url: "https://api.cpdiest.partheas.net"
        },
        "kiosk.dermatokliniek.partheas.net": {
            url: "https://api.dermatokliniek.partheas.net"
        },
        "kiosk.grimbergen.docleas.eu": {
            url: "https://api.grimbergen.docleas.eu"
        },
        "kiosk.torhout.docleas.eu": {
            url: "https://api.torhout.docleas.eu"
        },
        "kiosk.erpe-mere.docleas.eu": {
            url: "https://api.erpe-mere.docleas.eu"
        },
        "kiosk.oostkamp.docleas.eu": {
            url: "https://api.oostkamp.docleas.eu"
        },
        "kiosk.lochristi.docleas.eu": {
            url: "https://api.lochristi.docleas.eu"
        },
        "kiosk.kraainem.docleas.eu": {
            url: "https://api.kraainem.docleas.eu"
        },
        "kiosk.nottebohm.partheas.net": {
            url: "https://api.nottebohm.partheas.net"
        },
        "kiosk.berlaar.docleas.eu": {
            url: "https://api.berlaar.docleas.eu"
        },
        "kiosk.sint-lievens-houtem.docleas.eu": {
            url: "https://api.sint-lievens-houtem.docleas.eu"
        },
        "kiosk.vermeulenlaan.partheas.net": {
            url: "https://api.vermeulenlaan.partheas.net"
        },
        "kiosk.bkz.docleas.eu": {
            url: "https://api.bkz.docleas.eu"
        },
        "kiosk.brakel.docleas.eu": {
            url: "https://api.brakel.docleas.eu"
        },
        "kiosk.stekene.docleas.eu": {
            url: "https://api.stekene.docleas.eu"
        },
        "kiosk.blankenberge.docleas.eu": {
            url: "https://api.blankenberge.docleas.eu"
        }
    }
}